import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    margin: '0 0 0 0.5rem !important',
    fontSize: theme.size.sm,
    color: theme.palette.textLight
  },
  info: {
    marginLeft: '0.5rem'
  }
}))

export default useStyles
